const pdfReducer = (state = {id: null, display: 'none'}, action) => {
    switch(action.type)
    {
        case 'changePDF':
            state = action.pdf;
            return state;
        default :
            return state;
    }
}

export default pdfReducer;